import get from 'lodash.get';
import React, { useMemo } from 'react';
import routeQuery from '../RouteQuery.gql';
import useInfinitePagination from '@jetshop/core/hooks/useInfinitePagination';
import WindowedPage from '../Layout/WindowedPage/WindowedPage';

const WindowedCategory = ({ category, cacheHit, result, ...props }) => {
  const infinitePaginationProps = useInfinitePagination({
    result,
    query: routeQuery
  });

  const routePath = category.isDynamic ? null : get(result.data, 'route.path');
  const categoryPath = useMemo(() => routePath && { path: routePath }, [
    routePath
  ]);

  return (
    <WindowedPage
      infinitePaginationProps={infinitePaginationProps}
      cacheHit={cacheHit}
      loading={result.loading}
      categoryPath={categoryPath}
      filters={category.products.filters}
      sortOrders={category.products.sortOrders}
      title={category.name}
      total={category.products.totalResults}
      images={category.images}
      headerContent={category.content}
      breadCrumbText={category.breadcrumbText}
      parents={result.data?.route?.parents || null}
      {...props}
    />
  );
};

export default WindowedCategory;
